<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'businessContractList' }">
          合同列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <base-info ref="baseInfo" v-loading="loading" :info="form" />
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同附件信息
      </div>
      <div class="rj-page-card__content">
        <contract-file v-if="form.id" :contract-num="form.id" />
      </div>
    </div>
    <product-list ref="product" :form="form" :contract-num="contractNum" :project-name="form.projectName" :order-unit="form.orderUnit" :sold-country="form.soldCountry" />
    <DistributionInfoList v-if="form.id" :contract-id="form.id" :contract-status="form.contractStatus" />
    <dismissed-suggestion ref="approvalComments" :contract-id="form.id" />
    <actions :reject-loading="loading" :loading="loading" @handleSubmit="handleSubmit(2)" @handleReject="handleSubmit(0)" />
  </div>
</template>
<script type="es6">
import actions from '../components/Actions';
import actionMixin from './actionMixin';
import baseInfo from './BaseInfo';
import DistributionInfoList from './DistributionInfoList';
import dismissedSuggestion from './dismissedSuggestion';

import productList from './ProductList';
import contractFile from './ContractFile';
import axios, { getContractDetailAllInfoByConNum, getContractProductInfoByContractId } from '@/API';
export default {
  mixins: [actionMixin],
  data () {
    return {
      form: {},
      loading: false,
      rejectedLoading: false
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    },
    contractType: {
      type: String,
      default: () => { return ''; }
    }
  },
  components: {
    baseInfo,
    productList,
    actions,
    contractFile,
    dismissedSuggestion,
    DistributionInfoList
  },
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getContractDetailAllInfoByConNum(this.contractNum).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.$nextTick(() => {
            this.initProduct();
          });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    initProduct () {
      this.productLoading = true;
      axios.all([
        getContractProductInfoByContractId(this.form.id)
      ]).then((res) => {
        let fjson = res[0].data;
        this.productLoading = false;
        if (fjson.status === '200') {
          if (this.contractType === '国际分销下单' && fjson.data) {
            if (fjson.data[0].orderProductId === null && !fjson.data[0].serviceDesc) {
              this.$refs.product.productList = fjson.data;
            } else {
              let productList = [];
              let zeroList = [];
              fjson.data.forEach(item => {
                if (item.orderProductId) {
                  productList.push(item);
                  let l1Arr = [];
                  let l2Arr = [];
                  fjson.data.forEach(one => {
                    if (Number(one.serviceKeyList) === item.orderProductId && one.orderAmount) {
                      if (one.serviceLevel === 1) {
                        l1Arr.push(one);
                      } else if (one.serviceLevel === 2) {
                        l2Arr.push(one);
                      } else {
                        productList.push(one);
                      }
                    }
                  });
                  productList = [...productList, ...l1Arr, ...l2Arr];
                } else if (!item.orderAmount) {
                  zeroList.push(item);
                }
              });
              const merged = Array.from(
                zeroList.reduce((map, item) => {
                  const { productName } = item;
                  const existing = map.get(productName);
                  if (existing) {
                    existing.productNum += item.productNum;
                  } else {
                    map.set(productName, { ...item });
                  }
                  return map;
                }, new Map())
              ).map(([_, value]) => value);
              this.$refs.product.productList = [...productList, ...merged];
            }
          } else {
            this.$refs.product.productList = fjson.data;
          }
          // 让表格重新计算高度，防止合计被fixed属性破坏宽度
          this.$nextTick(() => {
            if (fjson.data.length > 10) {
              this.$refs.product.tableHeight = 500;
            } else {
              this.$refs.product.tableHeight = '';
            }
          });
        }
      }).catch(() => {
        this.productLoading = false;
      });
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
</style>
